module.exports = __webpack_public_path__ + "static/img/IMG_20160724_163410-PANO.e11f8a70.jpg";